import axios, { AxiosResponse, InternalAxiosRequestConfig } from "axios";
// @ts-ignore
import Cookies from "js-cookie";

import { HTTP_STATUS_CODE_MESSAGE } from "@/consts/http";
import { goLogin } from "@/router";
import defaultSettings from "@/settings";
import { useUserStoreHook } from "@/store/modules/user";
import LoadingInstance from "@/utils/loading";

// import { store } from "../store/index";
// 创建 axios 实例
const service = axios.create({
  baseURL: defaultSettings.apiBaseUrl,
  timeout: 50000,
  headers: { "Content-Type": "application/json;charset=utf-8" },
});

// 请求拦截器
service.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const isToken = (config.headers || {}).isToken === false;
    const accessToken = Cookies.get("access_token");
    if (accessToken && !isToken) {
      config.headers["Authorization"] = "Bearer " + accessToken; // token
    }
    if (config?.responseType === "blob") {
      LoadingInstance.getInstance();
    }

    // if (userInfo) {
    //   config.headers["UserId"] = simpleAes(userInfo.staffId);
    // }
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

const errorHandle = (error: any) => {
  const status = Number(error.response.status) || 500;
  const resData = error.response.data || {};
  const { msg } = resData;
  // 错误提示
  if (msg) {
    ElMessage({
      message: msg,
      grouping: true,
      type: "error",
    });
  } else {
    ElMessage({
      message:
        HTTP_STATUS_CODE_MESSAGE[status] || "系统未知错误,请反馈给管理员",
      grouping: true,
      type: "error",
    });
  }

  // 登录过期
  if ([401].includes(status)) {
    useUserStoreHook().resetAll();
    goLogin();
  }

  return Promise.reject(error);
};
// 响应拦截器
service.interceptors.response.use((res: AxiosResponse) => {
  const { code, msg } = res.data;

  // 请求异常处理, !== undefined指后天无法处理的情行，如登录接口
  if (code !== undefined && code !== 0) {
    // 状态已改变，提示刷新
    if (code === 5) {
      setTimeout(() => {
        location.reload();
      }, 3000);
    }
    ElMessage({
      message: msg || "系统未知错误,请反馈给管理员",
      grouping: true,
      type: "error",
    });
    return Promise.reject(res.data);
  }

  if (res.data instanceof ArrayBuffer || res.data instanceof Blob) {
    LoadingInstance.getInstance()?.hideLoading();
  }
  // 响应数据为二进制流处理(Excel导出)
  if (res.data instanceof ArrayBuffer) {
    return res;
  }

  return res.data;
}, errorHandle);

// 导出 axios 实例
export default service;
